import type {
  ComparisonValue,
  LOGIC_OPERATOR
} from '@epilot/journey-logic-commons/src/types/next'
import type { Schema } from 'zod'

import type { RuntimeContext } from './types'

export abstract class Operator<S = unknown, A = unknown> {
  public readonly name: LOGIC_OPERATOR
  private readonly factSchema?: Schema

  constructor(operator: LOGIC_OPERATOR, factSchema?: Schema) {
    this.name = operator
    this.factSchema = factSchema
  }

  /**
   * Parses the fact value throught defined zod schema if available,
   * otherwise returns the raw value
   *
   * @param factValue the given fact
   */
  parse(factValue: unknown) {
    if (this.factSchema) {
      return this.factSchema.parse(factValue)
    }

    return factValue
  }

  /**
   * Checks whether the fact value matches the comparison value, according
   * to the operators own logic.
   *
   * @param factValue the given fact
   * @param comparisonValue the comparison value defined in the logic
   */
  abstract evaluate(
    factValue: S,
    comparisonValue: ComparisonValue,
    context?: RuntimeContext,
    args?: A
  ): Promise<boolean> | boolean
}
